<template>
  <Form as="div" ref="form">
    <transition v-cloak name="modal">
      <v-modal
        :is-open="$store.state.cprConsent.stepTwoDeclined"
        :show-close-button="$store.state.cprConsent.showModalCloseButton"
        modal-class="alt-modal"
        @close="close"
      >
        <template #title>
          <h2 v-html="vueModel.DeclineModalTitle" />
        </template>
        <template #content>
          <div>
            <p v-html="vueModel.DeclineModalBody" />
            <radio-buttons-checkbox-style
              v-model="cprConsentDeclineConfirm"
              name="cpr-consent-decline-confirm"
              class="no-margin-bottom"
              :options="checkBoxOptions"
              :required-validation-override="decoder()"
            />
            <info-box
              v-if="cprConsentDeclineConfirm"
              info-box-class="info-box-warning"
              arrow-align="left"
              v-html="vueModel.ConfirmDeclineWarningMessage"
            />
          </div>
        </template>
        <template #buttons>
          <div class="row">
            <div class="columns small-6">
              <button
                id="regret"
                class="button large secondary"
                @click="regret"
                v-html="vueModel.CancelDeclineButtonText"
              />
            </div>
            <div class="columns small-6">
              <button
                id="submit"
                class="button large"
                @click="submit"
                v-html="vueModel.ConfirmDeclineButtonText"
              />
            </div>
          </div>
        </template>
      </v-modal>
    </transition>
  </Form>
</template>

<script>
import InfoBox from '@/components/UI/InfoBox.vue';

import RadioButtonsCheckboxStyle from './RadioButtonsCheckboxStyle.vue';
import UtilityFunctions from '@/common/UtilityFunctions.js';

export default {
  name: 'CprConsentDeclineModal',
  components: {
    
    InfoBox,
    RadioButtonsCheckboxStyle
  },
  data() {
    return {
      cprConsentDeclineConfirm: null
    };
  },
  computed: {
    vueModel() {
      return this.$store.state.cprConsent.vueModel;
    },
    checkBoxOptions() {
      return [
        {
          Text: this.vueModel.ConfirmDeclineText,
          Value: true
        }
      ];
    }
  },
  methods: {
    async submit() {
      let resultObj = await this.$refs.form.validate();
      if (resultObj.valid) {
        await this.$store.dispatch('cprConsent/submitStepTwoDeclined');
      }
    },
    regret() {
      this.$store.dispatch('cprConsent/regretStepTwoDeclined');
      this.cprConsentDeclineConfirm = null;
      this.dispatchTrackingEvent('cpr-consent-modal-no-regret');
    },
    close() {
      this.$store.dispatch('cprConsent/closeModalsByCross');
      this.cprConsentDeclineConfirm = null;
    },
    decoder() {
      return UtilityFunctions.decodeHtml(this.vueModel.ConfirmDeclineRequiredValidationMessage);
    },
    dispatchTrackingEvent(eventStr) {
      this.$store.dispatch('Events/register', {
        event: eventStr,
        id: 'cprConsentModal',
        vm: this
      });
    }
  }
};
</script>
